import { Flex, IllustratedMessage } from '@percent/lemonade';
import { Title, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Layout } from '@percent/grants-nomination-form/ui';

type ClosedNominationsProps = {
  deadline: Date;
  programName: string;
};

export const ClosedNominations = ({ deadline, programName }: ClosedNominationsProps) => {
  const { t, i18n } = useTranslation();

  const formattedDeadline = new Date(deadline).toLocaleDateString(i18n.language, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Layout>
      <Flex direction="column" align="center" gap={8} m="auto">
        <IllustratedMessage illustration="grants-nominations-closed" />
        <Title order={2} fz={24} fw={600} ta="center">
          {t('typography.nominationsClosedTitle')}
        </Title>
        <Text fz={14} ta="center">
          {t('typography.nominationsClosedDescription', {
            deadline: formattedDeadline,
            programName,
          })}
        </Text>
      </Flex>
    </Layout>
  );
};
